export default function Footer({ children, restOfProps }) {
	return <footer {...restOfProps} data-sentry-component="Footer" data-sentry-source-file="index.jsx">{children}</footer>;
}
